<template>
  <b-row
    align-h="start"
    no-gutters>
    <b-col md="auto">
      <b-navbar-brand href="#/">
        <img
          src="../../assets/arexo/revatech-new-logo.png"
          height="35"
          alt="">
      </b-navbar-brand>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasContactsModuleAccess"
          :active="activeTab === 'contacts'"
          @click="navigateToContactsModule">
          {{ $t('page.title.contacts') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasExitProcessModuleAccess"
          :active="activeTab === 'flows'"
          @click="navigateToFlowsModule">
          {{ $t('page.title.flow') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasExitProcessModuleAccess"
          :active="activeTab === 'exits'"
          @click="navigateToExitsModule">
          {{ $t('page.title.exits') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    hasContactsModuleAccess: Boolean,
    activeTab: String,
    navigateToContactsModule:Function,
    hasExitProcessModuleAccess: Boolean,
    navigateToExitsModule:Function,
    navigateToFlowsModule:Function
  }
};
</script>
